var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "breadcrumb" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { separator: "" } },
        _vm._l(_vm.breadcrumbConfig.list, function (item, index) {
          return _c(
            "el-breadcrumb-item",
            { key: index, attrs: { to: { path: item.path } } },
            [
              _c("div", { class: item.type == 1 ? "secondLevel" : "stair" }, [
                _vm._v(_vm._s(item.title)),
              ]),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }